import React, {useEffect, useState} from 'react';
import iziToast from 'izitoast';

import Paper from "@material-ui/core/Paper";
import {navigate} from "@reach/router";
import Divider from "@material-ui/core/Divider";
import VaultForm from "../VaultForm/VaultForm";
import routes from "../../utils/api-client";
import {updateVaultDetails} from "../../utils/helpers";
import {compose} from "redux";
import {connect} from "react-redux";
import {toggleLoading} from "../../redux/reducers/utils";
import {Helmet} from "react-helmet";
import './VaultCreate.scss';

function VaultEdit(props) {
  let [vault, setVault] = useState();

  useEffect(() => {
    if (props.user) {
      routes.getVault(props.vaultId).subscribe((response) => {
        const vault = updateVaultDetails(response.data);
        if (response.data.status !== 'LOCKED') {
          navigate(`/vaults/${props.vaultId}`)
          iziToast.error({
            position: "topCenter",
            'title': 'Error',
            'message': response.data.status !== 'ARCHIVED' ? 'Unable to edit Vault while it is Unlocked or there is a pending access request.' : 'Can not edit a Vault that has been Archived'
          });
        }

        setVault(vault);
        props.toggleLoading(false);
      });
    }
  }, [props.user]);

  const updateVault = (vaultData) => {
    props.toggleLoading(true);
    routes.updateVault(vault.id, vaultData).subscribe((response) => {
      if (response.status === 200) {
        navigate(`/vaults/${response.data.id}`);
        iziToast.success({
          position: "topCenter",
          'title': 'Success',
          'message': 'Successfully updated your vault.'
        });
      }
    });
  };

  return (
    !!vault &&
    <>
      <Helmet>
        <title>Fidelius Vaults: {vault.vault_name} (edit)</title>
      </Helmet>
      <Paper className="create-vault-container m-auto overflow-y-auto">
        <p className="font-bold text-3xl lg:text-5xl text-center">Edit Vault</p>
        <p className="text-sm lg:text-base text-center text-grey mt-2 sm:mt-0 mb-4">Follow the steps below to edit your vault.</p>
        <Divider variant="middle"/>
        <VaultForm saveVault={updateVault} vault={vault} allowedStep={5} editMode={true}/>
      </Paper>
    </>
  );
}


const mapStateToProps = (state, props) => {
  return {
    ...props,
    user: state.user.user,
  };
};

export default compose(
  connect(
    mapStateToProps,
    { toggleLoading }
  )
)(VaultEdit);
